<template>
    <td class="order-box">
        <a
            class="order-box__thumb"
            :href="'/product/' + orderItem.item.product.id + '?color_id=' + orderItem.item.color.id"
        >
            <img
                v-if="orderItem.item.colorProductImagePath"
                :src="orderItem.item.colorProductImagePath"
                alt="Product Image"
            />
            <img
                v-else-if="orderItem.item.product.imgPath"
                :src="orderItem.item.product.imgPath"
                alt="Product Image"
            />
            <img
                v-else
                src="/img/noimage.png"
                alt="Product Image"
            />
        </a>
        <div class="order-box__detail">
            <p class="name">
                <a
                    :href="
                        '/product/' +
                        orderItem.item.product.id +
                        '?color_id=' +
                        orderItem.item.color.id
                    "
                >
                    {{ orderItem.item.product.name }}
                </a>
            </p>
            <p class="color-name">{{ orderItem.item.color.name }}</p>
            <p class="size-name">{{ orderItem.item.size.name }}</p>
            <p class="price">
                {{ orderItem.item.price }}
                <span>/ 数量：　{{ orderItem.count }}個</span>
            </p>
        </div>
        <p
            v-if="isShowSubtotal"
            class="subtotal"
        >
            小計 ¥{{ orderItem.subtotal }}
        </p>
    </td>
</template>

<script>
import OrderItem from '../../models/OrderItem'

export default {
    name: 'order-product-item',
    props: {
        orderItem: {
            type: OrderItem,
        },
        isShowSubtotal: {
            type: Boolean,
            default: false,
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/order/OrderProductItem.vue